
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moja-karta/wymiana-karty/esim/karta-gotowa",
      function () {
        return require("private-next-pages/moje-konto/moja-karta/wymiana-karty/esim/karta-gotowa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moja-karta/wymiana-karty/esim/karta-gotowa"])
      });
    }
  